import { isFunction } from "lodash";

export function safeInvoke<A, R>(func: ((arg1: A) => R) | undefined, arg1: A): R | undefined;

export function safeInvoke(func: Function | undefined, ...args: any[]) {
    window.requestAnimationFrame((): void | undefined => {
        if (isFunction(func)) {
            return func(...args);
        }

        return undefined;
    });
}
